import { useState } from "react";
import { Table, Space, Button, message,Modal } from "antd";
import CareerService from "../../../services/CareerService.js";
import CareerModalForm from "./CareerModalForm";

const getColumns = (setCareerTarget, showModalForm, showModalDelete) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: "100px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
    {
      title: "Siglas",
      dataIndex: "shortName",
      width: "150px",
      key: "shortName",
      render: (text, record) => <span>{record.shortName}</span>,
    },
    {
      title: "Acciones",
      key: "action",
      width: "150px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setCareerTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setCareerTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
};
export default function Career({ list = [], getData, setCareers }) {
  const [careerTarget, setCareerTarget] = useState(null);
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);

  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    CareerService.deleteCareer(careerTarget)
      .then((res) => {
        if (res.data?.success) {
          message.success("Carrera eliminada.", 3);
          getData()
            .then((res) => {
              handleCancelDelete();
              setCareers(res);
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("No se pudo obtener la lista de carreras.", 5);
            });
        } else {
          message.error(
            "No se pudo eliminar la carrera. " + res.data?.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setCareerTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setCareerTarget(null);
        setIsModalFormVisible(false);
        setCareers(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de carreras.", 5);
      });
  };

  const handleCancelForm = () => {
    setCareerTarget(null);
    setIsModalFormVisible(false);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{marginBottom:"1em"}}
      >
        +Registrar nueva carrera
      </Button>
      <Table
        columns={getColumns(setCareerTarget, showModalForm, showModalDelete)}
        dataSource={list}
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      {isModalFormVisible ? (
        <CareerModalForm
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          careerTarget={careerTarget}
        />
      ) : null}
      {isModalDeleteVisible?(
        <Modal
        visible={isModalDeleteVisible}
        title="Eliminar Carrera"
        onOk={handleOkDelete}
        onCancel={handleCancelDelete}
        okText="Aceptar"
        cancelText="Cancelar"
      >
        <p>
          ¿Desea eliminar la carrera{" "}
          <strong>
            {careerTarget?.name + " - " + careerTarget?.shortName}
          </strong>
          ?
        </p>
      </Modal>
      ):null}
    </>
  );
}
